import React from 'react';
import { Row, Col, Well } from 'react-bootstrap';
import Slider from '@mygooder/react-slick';
import ServiceCard from './ServiceCard';
import { NextArrow, PrevArrow } from './../../shared/SliderArrows';

import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import find from 'lodash/find';

import './servicescardsslider.scss';

class ServicesCardsSlider extends React.Component {

  constructor(props) {
    super(props);
    this.handleAfterChange = this.handleAfterChange.bind(this);
    this.goToFirstCard = this.goToFirstCard.bind(this);
  }

  handleAfterChange(currentIndex) {

    const sliderCount = this.slider.props.children.length;
    const currentBreakpoint = this.slider.state.breakpoint;
    const currentSlidesToShow = (find(this.slider.props.responsive, ['breakpoint', currentBreakpoint]) || {}).settings.slidesToShow;

    if(sliderCount < currentSlidesToShow) return;

    const minShowIndex = Math.floor(currentSlidesToShow/2);
    let maxShowIndex = (sliderCount - 1) - minShowIndex;
    if(currentSlidesToShow % 2 == 0) maxShowIndex++;

    if(currentIndex < minShowIndex) {
      let self = this;
      setTimeout(function(){ 
        self.slider.slickGoTo(minShowIndex); 
      }, 0);
      return;
    }

    if(currentIndex > maxShowIndex) {
      let self = this;
      setTimeout(function(){ 
        self.slider.slickGoTo(maxShowIndex); 
      }, 0);
      return;
    }
  }

  goToFirstCard() {
    const currentBreakpoint = this.slider.state.breakpoint;
    const currentSlidesToShow = (find(this.slider.props.responsive, ['breakpoint', currentBreakpoint]) || {}).settings.slidesToShow;
    const minShowIndex = Math.floor(currentSlidesToShow/2);
    /* This defer prevents Key missing error when using inner slider into component lifecycle... :-| */
    let self = this;
    setTimeout(function(){ 
      self.slider.slickGoTo(minShowIndex); 
    }, 0);
  }

  componentDidMount() {
    this.goToFirstCard();
  }

  componentWillUpdate(nextProps) {
    if(this.props.services != nextProps.services) {
      this.goToFirstCard();
    }
  }

  render() {

    const slickSettings = {
      afterChange: this.handleAfterChange,
      swipeToSlide: false,
      infinite: false,
      centerMode: true,
      variableWidth: false,
      prevArrow: <PrevArrow/>,
      nextArrow: <NextArrow/>,
      responsive: [ 
        { breakpoint: 768, settings: { initialSlide: 0, slidesToShow: 1, slidesToScroll: 1, arrows: false } }, 
        { breakpoint: 1024, settings: { initialSlide: 0, slidesToShow: 2, slidesToScroll: 1, arrows: true } }, 
        { breakpoint: 9999, settings: { initialSlide: 0, slidesToShow: 3, slidesToScroll: 1, arrows: true } } 
      ]
    };

    const placeholderCards = [<div key={0}><ServiceCard/></div>, <div key={1}><ServiceCard/></div>, <div key={2}><ServiceCard/></div>, <div key={3}><ServiceCard/></div>];

    const serviceCards = this.props.services.apiData.map((service, index) => {
      return (<div key={service.id}> <ServiceCard {...service}/> </div>)
    });

    return (
      <Row className="customize-servicescardsslider-component">
        <Col xs={12}>
          <div className="customize-servicescardsslider-component__title-wrap">
            <h4><strong>{this.props.translate('customize.notice')}</strong></h4>
          </div>

          <Well bsSize="large">
            <Slider ref={c => this.slider = c } {...slickSettings} className="customize-servicescardsslider-component__slider">
              {
                this.props.services.apiData.length > 0 ? serviceCards : placeholderCards
              }
            </Slider>
          </Well>
        </Col>
      </Row>
    );
  }
}

ServicesCardsSlider.displayName = 'PagesCustomizeServicesCardsSlider';
ServicesCardsSlider.propTypes = {};
ServicesCardsSlider.defaultProps = {};

const mapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    services: state.services
  };
};

export default connect(mapStateToProps)(ServicesCardsSlider);



// WEBPACK FOOTER //
// ./components/pages/customize/ServicesCardsSlider.js